import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["css", "className", "style", "asChild", "checked", "disabled", "label", "id", "name", "children", "onChange"];
import React from "react";
import BaseCheckbox from "./components/BaseCheckbox";
import { BaseCheckboxContainer, BaseCheckboxText } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Checkbox = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var css = _ref.css,
    className = _ref.className,
    style = _ref.style,
    asChild = _ref.asChild,
    checked = _ref.checked,
    disabled = _ref.disabled,
    label = _ref.label,
    id = _ref.id,
    name = _ref.name,
    children = _ref.children,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(BaseCheckboxContainer, {
    children: [/*#__PURE__*/_jsx(BaseCheckbox, _extends({
      checked: checked,
      disabled: disabled,
      id: id,
      forwardedRef: forwardedRef,
      name: name,
      onCheckedChange: onChange
    }, props)), label && /*#__PURE__*/_jsx(BaseCheckboxText, {
      disabled: disabled,
      htmlFor: id,
      children: label
    })]
  });
});
Checkbox.displayName = "Checkbox";
export default Checkbox;